import { NavLink, Outlet } from 'react-router-dom';

const TABS = [
  { to: '/depenses/transactions', label: 'Transactions' },
  { to: '/depenses/categories', label: 'Catégories & règles' },
];

export default function ExpensesLayout() {
  return (
    <div className="space-y-4">
      {/* Header — pas de PeriodSwitcher global : chaque onglet gère sa période */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-lg font-semibold text-slate-900">Dépenses</h1>
      </div>

      {/* Tabs horizontaux scrollables */}
      <nav
        className="flex gap-1 overflow-x-auto pb-px border-b border-slate-200 -mb-px"
        role="tablist"
        aria-label="Sous-sections Dépenses"
      >
        {TABS.map(({ to, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            role="tab"
            className={({ isActive }) =>
              `shrink-0 px-3 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 rounded-t ${
                isActive
                  ? 'border-slate-800 text-slate-900 aria-selected:true'
                  : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300'
              }`
            }
            aria-selected={undefined}
          >
            {({ isActive }) => (
              <span aria-selected={isActive} role="tab">
                {label}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Contenu de la sous-page */}
      <Outlet />
    </div>
  );
}
